import { render, staticRenderFns } from "./importresult.vue?vue&type=template&id=95c2db0a&"
import script from "./importresult.vue?vue&type=script&lang=js&"
export * from "./importresult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports